// A fingerprint of some content: FNV-1a over its JSON with every object's keys sorted, so a copy read
// back from the database (whose jsonb reorders keys) matches the draft it came from. Landing pages
// keep the one they published, and the editor compares the draft's with it ("Changed since published");
// newsletters keep the one they copied ("Changed since you copied it").

/** JSON with every object's keys sorted, and undefined left out. */
export function canonicalJson(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(canonicalJson).join(',')}]`;
  if (value && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([, v]) => v !== undefined)
      .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
    return `{${entries.map(([k, v]) => `${JSON.stringify(k)}:${canonicalJson(v)}`).join(',')}}`;
  }
  return JSON.stringify(value) ?? 'null';
}

export function contentHash(value: unknown): string {
  const text = canonicalJson(value);
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return `${h.toString(16)}-${text.length}`;
}
